import Button from '@/main/components/shared/button/button';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import { ReassignForm } from '@/main/screens/order/reassignOrder/reassignScreenUtils';
import { getTranslateByKey } from '@/main/services/utils';
import { Control, useWatch } from 'react-hook-form';
import * as S from './styles';

interface ISubmitBar {
  control: Control<ReassignForm>;
  isLoadingSave: boolean;
  onBack: () => void;
}

export default function SubmitBar({
  control,
  isLoadingSave,
  onBack
}: Readonly<ISubmitBar>) {
  const hasAnyPartWithAction = useWatch({
    control,
    name: 'parts',
    compute: (parts: ReassignForm['parts']) =>
      parts.some(
        part =>
          part.selectedGuidQuoteSupplierItem !== null ||
          part.directAssign !== null
      )
  });

  const parts = useWatch({ control, name: 'parts' });

  return (
    <S.AreaButtons>
      <SecondaryButton
        id="id-reassignOrder-btn-back"
        type="button"
        onClick={onBack}
        style={{ marginLeft: 'auto' }}>
        {getTranslateByKey('information.back')}
      </SecondaryButton>
      <Button
        id="id-reassignOrder-btn-reassign"
        type="submit"
        isLoading={isLoadingSave}
        disabled={parts.length == 0 || !hasAnyPartWithAction}>
        {getTranslateByKey('information.reassignSupplier')}
      </Button>
    </S.AreaButtons>
  );
}
